/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React  from 'react';
import ReactDOM from "react-dom";
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import c3 from 'c3';
import 'c3/c3.css';
import HelpComponent from './HelpComponent';

class TerrainProfileModal extends React.Component {
    constructor() {
        super();
        this.state = {
            modalIsOpen: false,
            terrainHeight:[],
            terrainX:[]
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.terrainProfileOutput = this.terrainProfileOutput.bind(this);
    }
    componentWillMount(){
        window.main.OView.addEventListener("InputCompleted",this.terrainProfileOutput);
    }
    componentWillUnmount(){
        window.main.OView.removeEventListener("InputCompleted",this.terrainProfileOutput);
        window.main.OView.abortInput();
        window.main.OView.updateScreen();
    }
    openModal() {
        this.renderChart();
        this.setState({modalIsOpen: true});
    }
    closeModal() {
        this.setState({modalIsOpen: false,terrainHeight:[],terrainX:[]});
    }
    renderChart() {
        c3.generate({
            bindto: "#chart1",
            type: "spline",
            size: {
                width:800,
                height:600
            },
            legend: {
                hide: true
            },
            data: {
                x:'X',
                columns: [this.state.terrainX, this.state.terrainHeight],
            },
            axis: {
                x: {
                    tick: {
                        values: [this.state.terrainX[1],this.state.terrainX[100]]
                    },
                    label: {
                        text: '經度位置',
                        position: 'outer-center'
                    }
                },
                y: {
                    padding: {
                        top: 100,
                        bottom: 100
                    },
                    label: {
                        text: '高度(M)',
                        position: 'outer-middle'
                    }
                }
            },
            grid: {
                y: {
                    show: true
                }
            }
        });
      }
    terrainProfileOutput(event){
        if(event.success){
            window.alertify.success("請稍後 ......");
            let terrainHeight = ['Height'];
            let terrainBaseX = (event.geo.Buffer[1].x - event.geo.Buffer[0].x)/99;
            let terrainX = ['X'];
            for(let i=0;i<100;i++){
                terrainX.push(event.geo.Buffer[0].x + terrainBaseX*i)
            }
            let data = {
                "LAYERNAME":window.main.OView.name,
                "SAMPLE_SIZE":100,
                "EPSG":4326,
                "GEO":{
                    "type":"LineString",
                    "coordinates":[[event.geo.Buffer[0].x,event.geo.Buffer[0].y],[event.geo.Buffer[1].x,event.geo.Buffer[1].y]]
                }
            }
            const url = "http://140.110.20.123/Oview.aspx?http://127.0.0.1:8080/docmd?cmd=OV_GET_TERRAIN_PROFILE";
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(
                    data
                )
            })
            .then(res => res.json())
            .then((data) => {
                if(data.SUCCESS){
                    for(let i =0;i<data.PROFILE.length;i++){
                        terrainHeight.push(data.PROFILE[i]); 
                    }
                    this.setState({terrainHeight:terrainHeight,terrainX:terrainX});
                    this.openModal();
                }
                else{
                    window.alertify.error("發生錯誤，請再試一次");
                }
            });
        }
        else{
            window.alertify.error("發生錯誤，請再試一次");
        }
    }
    terrainProfileStart(){
        window.alertify.log("請點擊滑鼠左鍵開始選取範圍");
        window.main.OView.inputSurfacePolyline(null,null,null,null,2);
    }
    render() {
        let active ;
        if(this.state.modalIsOpen)
            active = "ts modals dimmer active";
        else
            active = "ts modals dimmer";
        
        return (
            <div className="content" id="AnalysisContent">
                <div className="header">
                    地形剖面
                </div>
                <div className="description">
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">
                            <div className="sixteen wide column">
                                <button className="ts circular  icon button" onClick={this.terrainProfileStart.bind(this)} style={{width:"100%"}}>
                                    <i className="checkmark icon"></i>
                                    開始
                                </button>
                            </div>                                                       
                        </div>
                    </div>
                </div>
                <div className={active}>
                    <dialog className="ts modal" open>
                        <i className="close icon" onClick={this.closeModal.bind(this)}></i>
                        <div className="header">
                            地形剖面結果
                        </div>
                        <div className="content">
                            <div id="chart1"></div>
                        </div>
                    </dialog>
                </div>                
            </div>
            
        );
    }
}

class ViewshedAnalysis extends React.Component{
    constructor(){
        super();
        this.state = {
            displayColorPicker: false,
            color: {
              r: '241',
              g: '112',
              b: '19',
              a: '1',
            },
            hexColor:"#F17013",
            viewshedRange:2000,
            posX:120.973882,
            posY:23.97565,
            posZ:1000
          };
        this.viewshedRangeChange = this.viewshedRangeChange.bind(this);
        this.posXChange = this.posXChange.bind(this);
        this.posYChange = this.posYChange.bind(this);
        this.posZChange = this.posZChange.bind(this);
        this.posClick = this.posClick.bind(this);
        this.startAnalysis = this.startAnalysis.bind(this);
        this.clearAnalysis = this.clearAnalysis.bind(this);
    }

    componentWillUnmount(){
        if(window.main!==null){
            window.main.OView.cursor = 'default';
            window.main.OView.analysis.ClearViewshedAnalysis();
            var _analysis = window.main.OView.findLayer("analysis");
            if(_analysis!==null){
                _analysis.removeAllEntity();
            }
        }
        window.main.OView.updateScreen();
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
      };
    
    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };
    
    handleChange = (color) => {
        this.setState({ color: color.rgb,hexColor:color.hex })
        
    };

    viewshedRangeChange(event){
        this.setState({ viewshedRange: event.target.valueAsNumber })
    }

    posXChange(event){
        this.setState({ posX: event.target.valueAsNumber })
    }

    posYChange(event){
        this.setState({ posY: event.target.valueAsNumber })
    }

    posZChange(event){
        this.setState({ posZ: event.target.valueAsNumber })
    }

    posClick(){
        var posThis = this;
        var _analysis = window.main.OView.findLayer("analysis");
        if (_analysis === null) {
            _analysis = window.main.OView.addCustomLayer({
                layername : "analysis"
            });
        }
        _analysis.removeAllEntity();
        if(window.main!==null){
            window.main.OView.analysis.ClearViewshedAnalysis();
            window.main.OView.cursor = 'crosshair';
            window.alertify.log("選定中心點並拉開可視範圍的圓");
            window.main.OView.inputCircle({},function(e){
                if(e.success){
                    window.main.OView.cursor = 'default';                    
                    var param = {};
                    param.geo = new window.GeoPoint(e.geo.center.x, e.geo.center.y, e.geo.center.z + 5);//幾何
                    param.color = "#FF0000";//紅色
                    param.opacity = 0.8;//不透明
                    param.size = 15;//大小
                    param.absHeight = true; //是否為絕對高              
                    _analysis.addPointEntity(param);
                    posThis.setState({
                        viewshedRange:e.geo.radius,
                        posX:e.geo.center.x,
                        posY:e.geo.center.y,
                        posZ:e.geo.center.z + 2
                    });
                }
                else{
                    window.main.OView.cursor = 'default';
                    window.alertify.error("設定座標失敗");
                }
            });
        }        
    }
    
    startAnalysis(){
        if(window.main!==null){
            var ViewshedCenter = new window.GeoPoint(
                this.state.posX,
                this.state.posY,
                this.state.posZ
            );
            var _analysis = window.main.OView.findLayer("analysis");
            if (_analysis === null) {
                _analysis = window.main.OView.addCustomLayer({
                    layername : "analysis"
                });
            }
            _analysis.removeAllEntity();
            var param = {};
            param.geo = new window.GeoPoint(this.state.posX, this.state.posY, this.state.posZ + 3);//幾何
            param.color = "#FF3300";//紅色
            param.opacity = 0.8;//不透明
            param.size = 15;//大小
            param.absHeight = true; //是否為絕對高              
            _analysis.addPointEntity(param);
            var ViewshedRange = this.state.viewshedRange;
            var ViewshedColor = this.state.hexColor;
            window.main.OView.analysis.viewshedAnalysis({
                center: ViewshedCenter,
                distance: ViewshedRange,
                absHeight: true,
                color: ViewshedColor,
                opacity: 1.0,
                epsg: null
            });
        }
    }

    clearAnalysis(){
        if(window.main!==null){
            window.main.OView.abortInput();
            window.main.OView.analysis.ClearViewshedAnalysis();
            var _analysis = window.main.OView.findLayer("analysis");
            if(_analysis!==null){
                _analysis.removeAllEntity();
            }
        }
    }

    render(){
        const styles = reactCSS({
            'default': {
              color: {
                width: '155px',
                height: '14px',
                borderRadius: '2px',
                background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
              },
              swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '10px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
                right: '0px'
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
              },
            },
          });
        return(
            <div className="content" id="AnalysisContent">
                <div className="header">
                    視域分析
                </div>
                <div className="description">
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">                    
                            <div className="eight wide column">
                                可視範圍顏色                                              
                            </div>
                            <div className="eight wide column">
                                <div>
                                    <div style={ styles.swatch } onClick={ this.handleClick }>
                                        <div style={ styles.color } />
                                        </div>
                                        { 
                                            this.state.displayColorPicker ? <div style={ styles.popover }>
                                            <div style={ styles.cover } onClick={ this.handleClose }/>
                                            <SketchPicker color={ this.state.color } onChange={ this.handleChange } />
                                            </div> : null 
                                        }
                                </div>                                            
                            </div>
                        </div>                        
                    </div>
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">                    
                            <div className="eight wide column">
                                範圍                                             
                            </div>
                            <div className="eight wide column">
                                <div class="ts mini circular input">
                                    <input type="number" placeholder="範圍" value={this.state.viewshedRange} onChange={(e)=>this.viewshedRangeChange(e)}></input>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">                    
                            <div className="eight wide column">
                                中心X座標                                           
                            </div>
                            <div className="eight wide column">
                                <div class="ts mini circular input">
                                    <input type="number" placeholder="中心X" value={this.state.posX} onChange={(e)=>this.posXChange(e)}></input>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">                    
                            <div className="eight wide column">
                                中心Y座標                                            
                            </div>
                            <div className="eight wide column">
                                <div class="ts mini circular input">
                                    <input type="number" placeholder="中心Y" value={this.state.posY} onChange={(e)=>this.posYChange(e)}></input>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">                    
                            <div className="eight wide column">
                                中心Z座標                                           
                            </div>
                            <div className="eight wide column">
                                <div class="ts mini circular input">
                                    <input type="number" placeholder="中心Z" value={this.state.posZ} onChange={(e)=>this.posZChange(e)}></input>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <div className="ts grid">
                        <div className="row">                    
                            <div className="six wide column">
                                <button className="ts circular icon button" onClick={this.posClick}>
                                    <i className="marker icon"></i>
                                    設定座標
                                </button>                                             
                            </div>
                            <div className="five wide column">
                                <button className="ts circular icon button" onClick={this.startAnalysis}>
                                    <i className="checkmark icon"></i>
                                    開始
                                </button>                                             
                            </div>
                            <div className="five wide column">
                                <button className="ts circular icon button" onClick={this.clearAnalysis}>
                                    <i className="trash outline icon"></i>
                                    清除
                                </button>                                               
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        );
    }
}

class SliceSpace extends React.Component{
    constructor(){
        super();
        this.setSliceSpace = this.setSliceSpace.bind(this);
        this.editSliceSpace = this.editSliceSpace.bind(this);
        this.removeSliceSpace = this.removeSliceSpace.bind(this);
        this.state = {isSliceSpace:false};
    }
    componentWillUnmount(){
        window.main.OView.abortInput();
        window.main.OView.updateScreen();
    }
    setSliceSpace(){
        if(window.main!==null){
            window.alertify.log("此功能適用於3D圖層中的建物、點雲、傾斜攝影，請開啟圖層後使用");
            window.alertify.log("左鍵點擊後開始");
            window.main.OView.setSliceSpace();
            this.setState({isSliceSpace:true});
        }
    }
    editSliceSpace(){
        window.main.OView.editSliceSpace();
    }
    removeSliceSpace(){
        window.main.OView.abortInput();
        window.main.OView.removeSliceSpace();
        this.setState({isSliceSpace:false});
    }
    render(){
        return(
            <div className="content" id="AnalysisContent">
                <div className="header">
                    模型切割
                </div>
                <div className="description">
                    <div className="ts grid">
                        <div className="row" id="surveyingRow">
                            <div className="five wide column">
                                <button className="ts circular  icon button" onClick={this.setSliceSpace.bind(this)}>
                                    <i className="checkmark icon"></i>
                                    開始
                                </button>
                            </div>
                            <div className="five wide column">
                                {
                                    this.state.isSliceSpace?
                                    <button className="ts circular icon button" onClick={this.editSliceSpace.bind(this)}>
                                        <i className="write icon"></i>
                                        編輯
                                    </button> 
                                    :
                                    <button className="ts circular disabled icon button">
                                        <i className="write icon"></i>
                                        編輯
                                    </button> 
                                }                                                                            
                            </div>
                            <div className="five wide column">
                                {
                                    this.state.isSliceSpace?
                                    <button className="ts circular icon button" onClick={this.removeSliceSpace.bind(this)}>
                                        <i className="trash outline icon"></i>
                                        清除
                                    </button> 
                                    :
                                    <button className="ts circular disabled icon button">
                                        <i className="trash outline icon"></i>
                                        清除
                                    </button> 
                                }                                              
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        );
    }
}

class Analysis extends React.Component{
    constructor(){
        super();
        this.closeCard = this.closeCard.bind(this);
        this.viewshedAnalysis = this.viewshedAnalysis.bind(this);
        this.sliceSpace = this.sliceSpace.bind(this);
        this.terrainProfile = this.terrainProfile.bind(this);
        this.comingSoon = this.comingSoon.bind(this);
        this.state = {
            type:"",
            helpMode : "None"
        };
    }
    viewshedAnalysis(){
        this.setState({type:"視域分析"});
    }
    sliceSpace(){
        this.setState({type:"模型切割"});
    }
    terrainProfile(){
        this.setState({type:"地形剖面"});
    }
    comingSoon(){
        this.setState({type:""});
    }
    closeCard(){
        this.props.setAnalysisOpen();
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        switch(this.state.helpMode){
            case "AnalysisHelp" : 
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/XlmQ8-Kf0cU" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
                break;
            case "SliceSpaceHelp" : 
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/Tiy6II851Uc" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
                break;
            case "TerrainProfileHelp" : 
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/OE11cfTG6nQ" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
                break;
            case "None" :
                ReactDOM.unmountComponentAtNode(document.getElementById('Help')); 
                break;
            default :
                break;
        }
        return(
            <div className="ts card" id="surveying" style={{zIndex:"100"}}>
                <div className="extra content">
                    <div className="actions">
                        <div className="ts separated icon buttons">
                            <button className="ts circular icon button" onClick={this.closeCard.bind(this)}>
                                <i className="remove icon"></i>
                            </button>
                        </div>
                    </div>
                    <div className="header">
                        <i className="bar chart icon"></i>
                        分析功能
                    </div>
                    <div className="meta">
                        <div>
                            點擊下方按鈕選擇功能
                        </div>
                    </div>
                </div>
                <div className="extra content" id="AnalysisContent">
                    <div className="ts two cards" >
                        <a className="ts card" onClick={this.viewshedAnalysis.bind(this)}>
                            <div className="content">
                                <div className="header">
                                    視域分析
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("AnalysisHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </div>
                                <div className="description">
                                    站在中心點找到所有你能看到的世界
                                </div>
                            </div>
                        </a>
                        <a className="ts card" onClick={this.sliceSpace.bind(this)}>
                            <div className="content">
                                <div className="header">
                                    模型切割
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("SliceSpaceHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </div>
                                <div className="description">
                                    你將會在這裡看見一間房子裡的所有情況
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="ts two cards" >
                        <a className="ts card" onClick={this.terrainProfile.bind(this)}>
                            <div className="content">
                                <div className="header">
                                    地形剖面
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("TerrainProfileHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </div>
                                <div className="description">
                                    地形的起伏，一眼看穿
                                </div>
                            </div>
                        </a>
                        <a className="ts card" onClick={this.comingSoon.bind(this)}>
                            
                        </a>
                    </div>
                </div>
                {
                    (()=>{
                        switch(this.state.type){
                            case "視域分析":return <ViewshedAnalysis />; break;
                            case "模型切割":return <SliceSpace />; break;
                            case "地形剖面":return <TerrainProfileModal />; break;
                            default:return null;
                            }
                        }
                    )()
                }
            </div>            
        );
    }
}
export default Analysis